import { AxiosError } from 'axios';
import ActionError from './ActionError';

export const repackageAxiosError = (error: AxiosError, baseMsg: string) => {
  const msgFromApi = (error.response?.data as { message?: string })?.message;
  const msgFromError = error.message;
  let detailMsg;
  if (msgFromApi) {
    detailMsg = msgFromApi;
  } else if (msgFromError === 'Request failed with status code 304') {
    detailMsg = 'No changes have been applied';
  } else {
    detailMsg = msgFromApi || msgFromError || '';
  }
  if (msgFromApi) {
    // API provided a specific message — use it directly without the generic prefix
    return new Error(msgFromApi);
  }
  if (detailMsg && detailMsg !== baseMsg) {
    return new Error(`${baseMsg}: ${detailMsg}`);
  }
  return new Error(detailMsg || baseMsg);
};

interface GetErrorMessageProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  resourceName?: string;
  defaultMessage: string;
}

export const getErrorMessage = ({
  error,
  resourceName: _resourceName,
  defaultMessage,
}: GetErrorMessageProps) => {
  const resourceName = _resourceName || 'resource';
  if (
    error instanceof AxiosError ||
    error instanceof ActionError ||
    error.name === 'ActionError'
  ) {
    let resStatus, msgFromApi;
    if (error instanceof AxiosError) {
      resStatus = error.response?.status;
      msgFromApi = error.response?.data?.message;
    } else {
      resStatus = error.statusCode;
      msgFromApi = error.message;
    }

    if (resStatus === 400) {
      return msgFromApi || defaultMessage;
    }
    if (resStatus === 401) {
      return 'Please (re)login and try again';
    }
    if (resStatus === 403) {
      return `You are not authorized to access this ${resourceName}`;
    }
    if (resStatus === 404) {
      return `The ${resourceName} does not exist`;
    }
    return defaultMessage || msgFromApi;
  }
  return defaultMessage;
};
